import { render, staticRenderFns } from "./member-card.vue?vue&type=template&id=20fa0016&scoped=true"
import script from "./member-card.vue?vue&type=script&lang=js"
export * from "./member-card.vue?vue&type=script&lang=js"
import style0 from "./member-card.vue?vue&type=style&index=0&id=20fa0016&prod&scoped=true&lang=scss"
import style1 from "./member-card.vue?vue&type=style&index=1&id=20fa0016&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fa0016",
  null
  
)

export default component.exports